/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import template from './review-reject-modal.component.html';
import {REJECTED_REASONS} from './review-commons';
import {CreativeApiService} from '../creative/creative-api.service';
import {LineItemApiService} from '../line-item/line-item-api.service';
import {APP_SHARED} from '../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule, TranslateModule],
  selector: 'adn-review-reject-modal',
  template
})
export class ReviewRejectModalComponent {
  reviewItem: any;
  creative: any;
  onComplete: () => void;

  rejectedReason: string;
  reasons = REJECTED_REASONS;
  form: any = {};

  constructor(
    public bsModalRef: BsModalRef,
    private readonly creativeApi: CreativeApiService,
    private readonly lineItemApi: LineItemApiService,
  ) {
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  review(): void {
    const creativeUpdate = {
      id: this.creative.creative.id,
      userState: 'REJECTED',
      rejectedReason: this.rejectedReason
    };

    firstValueFrom(this.creativeApi.save(creativeUpdate)).then(() => {
      return firstValueFrom(this.lineItemApi.savePartial({
        id: this.reviewItem.lineItem.id,
        userState: 'PROPOSED'
      }, 'userState')).catch(() => {
        this.form.bulkError = true;
      }).finally(() => {
        this.onComplete?.();
        this.bsModalRef.hide();
      });
    }, () => {
      this.form.bulkError = true;
      this.onComplete?.();
      this.bsModalRef.hide();
    });
  }
}
